import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import * as api from '../../app/api';

export const fetchTrackingInfo = createAsyncThunk(
  'home/fetchTrackingInfo',
  async (params, { getState, requestId }) => {
    const { currentRequestId, loading } = getState().home;

    if (loading !== 'pending' || requestId !== currentRequestId) {
      return;
    }

    try {
      const data = await api.fetchTrackingInfo(params);

      return data;
    } catch (e) {
      throw new Error(e.response?.data?.reason);
    }
  }
);

const homeSlice = createSlice({
  initialState: {
    tracking: [],
    total: 0,
    loading: 'idle',
    currentRequestId: undefined,
    error: null,
  },
  name: 'home',
  reducers: {
    reset: (state) => {
      state.tracking = [];
      state.total = 0;
    },
  },
  extraReducers: {
    [fetchTrackingInfo.pending]: (state, { meta }) => {
      if (state.loading === 'idle') {
        state.currentRequestId = meta.requestId;
        state.error = null;
        state.loading = 'pending';
      }
    },
    [fetchTrackingInfo.fulfilled]: (state, { meta, payload }) => {
      if (
        state.loading === 'pending' &&
        state.currentRequestId === meta.requestId
      ) {
        state.currentRequestId = undefined;
        state.loading = 'idle';
        state.total = payload.total;
        state.tracking = payload.data;
      }
    },
    [fetchTrackingInfo.rejected]: (state, { meta, error }) => {
      if (
        state.loading === 'pending' &&
        state.currentRequestId === meta.requestId
      ) {
        state.currentRequestId = undefined;
        state.error = error;
        state.loading = 'idle';
      }
    },
  },
});

export const { reset } = homeSlice.actions;

export const selectTotal = (state) => state.home.total;
export const selectTracking = (state) => state.home.tracking;

export default homeSlice.reducer;
